import React from 'react';
import { parse } from 'qs';

const parseQueryParams = ({ search }) => {
  const query = parse(
    (search || '').indexOf('?') === 0 ? search.substr(1) : search
  );
  if (typeof query.email === 'string') {
    // qs decodes "+" as a space (same x-www-form-urlencoded convention as
    // querystring); links that embed a raw, unescaped "+" in an email
    // (e.g. gmail plus-addressing) arrive here with it corrupted into a
    // space. Real email addresses never contain a literal space, so it's
    // safe to reverse that specific corruption.
    query.email = query.email.replace(/ /g, '+');
  }
  return query;
};

const withQuery = Component => props => {
  // eslint-disable-next-line react/prop-types
  const { location, ...rest } = props;
  return (
    <Component
      {...{
        ...rest,
        location: {
          ...location,
          query: parseQueryParams(location),
        },
      }}
    />
  );
};

export default withQuery;



// WEBPACK FOOTER //
// ./src/common/components/withQuery/index.js